import { render, staticRenderFns } from "./DocumentPreview.vue?vue&type=template&id=099b3246&scoped=true"
import script from "./DocumentPreview.vue?vue&type=script&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreview.vue?vue&type=style&index=0&id=099b3246&prod&lang=scss"
import style1 from "./DocumentPreview.vue?vue&type=style&index=1&id=099b3246&prod&lang=scss&scoped=true"
import style2 from "./DocumentPreview.vue?vue&type=style&index=2&id=099b3246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b3246",
  null
  
)

export default component.exports